export enum LoginCheckStatus {
  Register = 'register',
  Authorize = 'authorize',
  Restore = 'restore',
  Resume = 'resume',
}
